<template>
	<div
		class="unsplash-item"
		data-cy="upsplash-item"
		@click.stop="processCrop"
	>
		<img
			:src="item.thumbnail"
			class="unsplash-item__thumbnail"
		>

		<transition name="fade">
			<div
				v-if="!loading"
				class="unsplash-item__overlay"
			>
				<helio-icon
					token="plus-circle"
					weight="light"
					class="unsplash__add"
				/>
			</div>

			<div
				v-if="loading"
				class="unsplash-item__loading"
			>
				<helio-spinner
					color="blue"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
import Icon from '../../icon/Icon.vue';
import Spinner from '../../spinner/Spinner.vue';

export default {
	components: {
		'helio-icon': Icon,
		'helio-spinner': Spinner,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		processCrop() {
			this.loading = true;
			this.$emit('selected', this.item);
			this.$root.$emit('initiate-crop', this.item);
		},
	},
};
</script>

<style lang="scss" src="./unsplash-item.scss" />
